<template>
  <div :class="wrapperClasses">
    <input
      :id="inputId"
      type="checkbox"
      class="custom-control-input"
      :class="inputStateClass"
      :checked="isChecked"
      :disabled="disabled"
      :name="name"
      :value="nativeValue"
      v-bind="inputAttrs"
      @change="handleChange"
    />
    <label :for="inputId" class="custom-control-label">
      <slot />
    </label>
  </div>
</template>

<script>
import { defineComponent } from 'vue';

let uid = 0;

export default defineComponent({
  name: 'HdFormCheckbox',

  inheritAttrs: false,

  props: {
    checked: {
      type: [Boolean, String, Number],
      default: null
    },
    modelValue: {
      type: [Boolean, String, Number],
      default: undefined
    },
    value: {
      type: [Boolean, String, Number],
      default: true
    },
    name: {
      type: String,
      default: null
    },
    switch: {
      type: Boolean,
      default: false
    },
    switchVariant: {
      type: String,
      default: null
    },
    size: {
      type: String,
      default: null,
      validator: (value) => value == null || ['sm', 'lg'].includes(value)
    },
    disabled: {
      type: Boolean,
      default: false
    },
    state: {
      type: [Boolean, String],
      default: null
    }
  },

  emits: ['input', 'update:modelValue', 'change'],

  data() {
    return {
      localUid: `hd-form-checkbox-${uid += 1}`
    };
  },

  computed: {
    isChecked() {
      const current = this.modelValue !== undefined ? this.modelValue : this.checked;

      if (Array.isArray(current)) {
        return current.includes(this.value);
      }

      return !!current;
    },

    wrapperClasses() {
      const classes = [
        'custom-control',
        this.switch ? 'custom-switch' : 'custom-checkbox'
      ];

      if (this.size === 'lg') classes.push('custom-control-lg');
      if (this.size === 'sm') classes.push('custom-control-sm');
      if (this.$attrs.class) classes.push(this.$attrs.class);

      return classes.flat().filter(Boolean);
    },

    inputStateClass() {
      if (this.state === true) return 'is-valid';
      if (this.state === false) return 'is-invalid';

      return null;
    },

    inputId() {
      return this.$attrs.id || this.localUid;
    },

    inputAttrs() {
      const { id: _id, class: _class, ...attrs } = this.$attrs;

      return attrs;
    },

    nativeValue() {
      return this.value;
    }
  },

  methods: {
    handleChange(event) {
      let nextValue;

      if (Array.isArray(this.modelValue !== undefined ? this.modelValue : this.checked)) {
        const current = [...(this.modelValue !== undefined ? this.modelValue : this.checked)];
        const index = current.indexOf(this.value);

        if (event.target.checked && index === -1) current.push(this.value);
        if (!event.target.checked && index !== -1) current.splice(index, 1);

        nextValue = current;
      } else {
        nextValue = event.target.checked;
      }

      this.$emit('input', nextValue);
      this.$emit('update:modelValue', nextValue);
      this.$emit('change', nextValue);
    }
  }
});
</script>
